<!--  -->
<template>
  <div class="app-content">
    <div style="width: 100%; height: 100%;">
      <div class="top-title-container">
        <img src="../assets/lunbo4.jpg"
             alt=""
             class="top-title-container1">
        <div class="top-area">
          <div class="communion-title">活动报名</div>
        </div>
      </div>
      <div class="communion-list-container">
        <div class="communion-name">全部活动</div>
        <div class="list-content">
          <div>
            <div v-for="(event, index) in meetingList"
                 :key="index"
                 class="communion-item"
                 @click="goJinQiHuoDongDetail(event)">
              <div class="item-left">
                <img :src="event.photo"
                     alt=""
                     class="item-left1">
              </div>
              <div class="item-right">
                <div class="item-right-type">{{ event.name }}</div>
                <div class="item-right-name">
                  <div class="item-right-address">集体活动| {{ event.address }}</div>
                </div>
                <div class="item-right-explain">{{ event.beginDate +"-" + event.endDate}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      meetingList: []
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},

  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    localStorage.setItem("memorialsItems", [])
    localStorage.setItem("agencies", [])
    this.fetchData()
  },
  // 方法集合
  methods: {
    async fetchData() {
      try {
        const data = await this.$http.get('/tempt/api/sjte/getActivities'); // 通过this.$http调用全局挂载的axios实例发送GET请求，这里的/api/some-endpoint根据实际后端接口调整
        this.meetingList = data.result; // 如果请求成功，将返回的数据赋值给data属性用于展示
        this.$store.commit("updateMeetingList", this.meetingList);
      } catch (error) {
        console.log("error")
      } finally {
        console.log("error2")
      }
    },
    goJinQiHuoDongDetail(event) {
      this.$store.commit("updateMeetingId", event.id);
      this.$router.push('/jinqihuodongdetail');
      localStorage.setItem("jinqihuodongdetailIdId", event.id)

    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.app-content {
}

.top-title-container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 211px;
  background-size: cover;
  z-index: -2;
}

.top-title-container1 {
  width: 100%;
  height: 211px;
}

.top-area {
  position: absolute;
  top: 0;
  margin-left: 16px;
  z-index: 1;
}

.communion-title {
  padding-top: 132px;
  font-family: PingFangSC-Semibold;
  font-size: 28px;
  color: #fff;
  letter-spacing: 0;
}

.communion-list-container {
  height: calc(100% - 167px);
  background: #fff;
  border-radius: 16px 16px 0 0;
  z-index: 2;
  margin-top: -20px;
}

.communion-name {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #000;
  letter-spacing: 0;
  padding: 16px 0 0 16px;
}

.list-content {
}

.communion-item {
  display: flex;
  flex-direction: row;
  padding: 16px;
}

.item-left {
  width: 105px;
}

.item-left1 {
  width: 105px;
  height: 105px;
  background-size: cover;
  border: 0 solid #979797;
  border-radius: 8px;
  -o-object-fit: cover;
  object-fit: cover;
}

.item-right {
  margin-left: 16px;
  width: 65%;
}

.item-right-type {
  font-family: PingFangSC-Medium;
  font-weight: 400;
  font-size: 16px;
  color: #000;
  letter-spacing: 0;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-right-name {
  font-family: PingFangSC-Regular;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  background: hsla(0, 0%, 100%, 0.1);
  border-radius: 2px;
  border: 1px solid #007aaa;
  font-size: 12px;
  color: #007aaa;
  letter-spacing: 0;
  margin-bottom: 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.item-right-address {
  margin: 1px 4px;
  font-size: 10px;
}
.item-right-explain {
  letter-spacing: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 30%;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>